import timeGridPlugin from '@fullcalendar/timegrid';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
export const dayMap = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
};
export const reverseDayMap = {
    0: 'sunday',
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday',
};
export const defaultCalendarSettings = {
    plugins: [timeGridPlugin, dayGridPlugin, interactionPlugin],
    minTime: {
        hours: 7,
    },
    maxTime: {
        hours: 19,
    },
    scrollTime: {
        hours: 8,
        minutes: 0,
    },
    contentHeight: 1080,
    defaultView: 'timeGridWeek',
    firstDay: 1,
    nowIndicator: true,
    dragScroll: true,
    selectable: true,
    selectMirror: true,
    slotDuration: {
        minutes: 5,
    },
    slotLabelFormat: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        meridiem: false,
        omitZeroMinute: false,
    },
};
export const businessHours = (hours) => {
    const businessHours = [];
    hours.forEach((hour) => {
        businessHours.push({
            daysOfWeek: [dayMap[hour.id || '']],
            startTime: hour.starts_at || '',
            endTime: hour.ends_at || '',
        });
    });
    return businessHours;
};
